module.exports = __webpack_public_path__ + "img/aircon_auto_on_border.a515b38c.png";